export default __webpack_public_path__ + "ca75b4d567913a34ec08de0a23ec9ff7.png";